import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { PAGES_ENDPOINTS } from "../../config/api";
import { Button } from "../../components/common/Button";
import { useAuth } from "../../contexts/AuthContext";

// Pagina di login per gli utenti
// Gestisce l'autenticazione e il reindirizzamento dopo il login
// Utilizza fetch per inviare le credenziali al backend
// Se le credenziali sono corrette, salva il token e reindirizza alla homepage
// Se le credenziali non sono corrette, mostra un messaggio di errore
export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      await login(email, password);
      navigate(PAGES_ENDPOINTS.HOME);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleLogin}
        className="bg-white shadow-md rounded px-8 py-6 w-full max-w-sm"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>

        {error && <div className="text-red-600 text-sm mb-4">{error}</div>}

        <label className="block text-gray-700 text-sm mb-2">Email</label>
        <input
          type="email"
          className="border border-gray-300 rounded w-full px-3 py-2 mb-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label className="block text-gray-700 text-sm mb-2">Password</label>
        <input
          type="password"
          className="border border-gray-300 rounded w-full px-3 py-2 mb-4"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <div className="flex justify-between ">
          <Button
            type="submit"
            variant="primary"
          >
            Accedi
          </Button>
          <Link
            className="text-sm text-blue-500 mt-2 hover:underline"
            to={PAGES_ENDPOINTS.FORGOT_PASSWORD}>
            Password dimenticata?
          </Link>
        </div>
      </form>
    </div>
  );
}
